module.exports = __webpack_public_path__ + "img/sponsor.a14e234c.png";